import React, { useContext } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  IconButton,
  useTheme,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SearchIcon from "@mui/icons-material/Search";
import { AppContext } from "../../App";

const PricelistInfoSection = () => {
  const { userRecord } = useContext(AppContext);
  const theme = useTheme();

  if (!userRecord?.activePricelist) {
    return (
      <Card sx={{ mb: 3, p: 2, backgroundColor: theme.palette.background.paper, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          No Active Pricelist
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You don't have an active pricelist assigned. Please contact your administrator or select a pricelist to get started.
        </Typography>
      </Card>
    );
  }

  return (
    <Card sx={{ mb: 3, p: 2, backgroundColor: theme.palette.background.paper, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Active Pricelist Information
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography variant="body1">
          <strong>Name:</strong> {userRecord.activePricelist.name}
        </Typography>
        <Typography variant="body1">
          <strong>Total Parts:</strong> {userRecord.activePricelist.validRows || 0}
        </Typography>
        <Typography variant="body1">
          <strong>Last Updated:</strong>{" "}
          {new Date(userRecord.activePricelist.updatedAt).toLocaleDateString()}
        </Typography>
        {userRecord.activePricelist.notes && (
          <Typography variant="body1">
            <strong>Notes:</strong> {userRecord.activePricelist.notes}
          </Typography>
        )}
      </Box>
    </Card>
  );
};

export default PricelistInfoSection;
